export interface FileQueueItem {
    frm: FormData;
    hash: string;
    progress: number;
    status: string;
}
export class FileHash {
    constructor(public hash: string, public idProyecto: number) {
    }
}
